import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const RS: DeepPartial<Payments> = {
    quickOwnTransfer: {
        enabled: true,
    },
};
